module.exports = ".rotate-text{\r\n    display: inline-block;\r\n  -webkit-writing-mode: vertical-rl;\r\n  -ms-writing-mode: tb-rl;\r\n  writing-mode: vertical-rl;\r\n  -webkit-transform: rotate(180deg);\r\n          transform: rotate(180deg);\r\n  border: 0;\r\n  padding: 6px;\r\n  width:100%;\r\n}"


//////////////////
// WEBPACK FOOTER
// ./src/app/reports/clear-vacant-property/clear-vacant-property.component.css
// module id = ./src/app/reports/clear-vacant-property/clear-vacant-property.component.css
// module chunks = main